import { getDocs, query, where } from "firebase/firestore";
import { inventoryCollection } from "./firebase";
import { getSelectedCustomer } from "./utils";

export const getInventoryDataService = async () => {
    const { district_id, customer_id } = getSelectedCustomer();
    const districtCustomer = `${district_id}${customer_id}`;
    const q = query(inventoryCollection, where("districtCustomer", "==", districtCustomer));

    const snapshot = await getDocs(q);
    return snapshot;
    // 2. Map the data (more concise than forEach)
};
